import styles from "./scientific-writing-communication.module.css";
import ServicoDetalheCover from "../../../components/ServicosComponents/ServicoDetalheCover/servico-detalhe-cover";
import { NavLink } from "react-router-dom";

const ScientificWritingCommunication = () => {
  return (
    <main className={styles.servico_detalhe_main}>
      <ServicoDetalheCover
        title="Scientific Writing & Communication"
        alt="Cover da página Scientific Writing & Communication."
      />
      <section className={styles.descricao_section}>
        <div className={styles.text}>
          <p className={styles.text_paragraph}>
            Produzimos documentos de <b> escrita científica</b> relacionada à
            análise de dados de mundo real <b> (RWD)</b> em múltiplas formas,
            incluindo:
          </p>
          <ul className={styles.servico_lista}>
            <li className={styles.lista_item}>
              • Resumos para submissão a eventos científicos
            </li>
            <li className={styles.lista_item}>
              • Artigos científicos para submissão a periódicos
            </li>
            <li className={styles.lista_item}>
              • Relatórios de análises de dados
            </li>
            <li className={styles.lista_item}>
              • Clinical Statistical Reports{" "}
            </li>
            <li className={styles.lista_item}>• Sumários de estudos</li>
            <li className={styles.lista_item}>
              • Textos para comunicação científica
            </li>
          </ul>
        </div>

        <div className={styles.text}>
          <p className={styles.text_paragraph}>
            Além de relatórios produzimos{" "}
            <b>materiais visuais personalizáveis</b>, seguindo a identidade
            visual do cliente, para comunicação científica em geral, incluindo:
          </p>
          <ul className={styles.servico_lista}>
            <li className={styles.lista_item}>• Slide-decks de apresentação</li>
            <li className={styles.lista_item}>• Infográficos</li>
          </ul>
        </div>

        <div className={styles.text}>
          <p className={styles.text_paragraph}>
            Os produtos de escrita e comunicação científica são produzidos
            considerando o público-alvo e normas relacionadas à aplicação do
            material a ser desenvolvido.
          </p>
        </div>
        <div className={styles.btns_div}>
          <NavLink to="/produtos/trainings-workshops">
            <button className={styles.btn_produto}>
              {" Ver Trainings & Workshops"}
            </button>
          </NavLink>
          <NavLink to="/produtos/masterclasses">
            <button className={styles.btn_produto}>
              {"Ver Masterclasses"}
            </button>
          </NavLink>
        </div>
        <div className={styles.btns_divMobile}>
          <NavLink to="/produtos/trainings-workshops">
            <button className={styles.btn_produto}>
              {"<"}
            </button>
          </NavLink>
          <NavLink to="/produtos/masterclasses">
            <button className={styles.btn_produto}>
              {">"}
            </button>
          </NavLink>
        </div>
      </section>
    </main>
  );
};

export default ScientificWritingCommunication;
